import React from "react"

import DownloadLink from "./download-link"

const SuccessScreen = () => {
  return (
    <div className="flex w-full flex-col px-4 pb-8 pt-20">
      <h1 className="mb-2 text-xl font-bold text-nelo-blue">¡Gracias por tu orden!</h1>
      <p className="mb-4 text-ui-fg-base">Te enviaremos un correo electrónico con tu confirmación.</p>
      <div className="relative overflow-hidden rounded-lg bg-gradient-to-br from-nelo-blue via-blue-200 via-blue-300 via-blue-400 to-nelo-blue p-8 shadow-lg">
        <div className="relative z-10">
          <h2 className="mb-4 text-xl font-bold text-white">Descarga la app Nelo para usar tu crédito aprobado.</h2>
          <p className="text-white">Compra en línea, retira efectivo, paga tus servicios y haz recargas. Todo a quincenas desde la app.</p>
          <div className="flex items-start justify-start">
            <DownloadLink />
          </div>
        </div>
      </div>
    </div>
  )
}

export default SuccessScreen
